export default __webpack_public_path__ + "static/media/330_dummy2016-friseur01-de.7ec1acd0.png";